import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("input", { hidden: "" }, null, -1)

import {Button} from "@/components/ui/button";
  import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter, DialogHeader, DialogTitle
  } from "@/components/ui/dialog";
  import {Input} from "@/components/ui/input";
  import {computed, ref, watch} from "vue";
  import useEventsBus from "@/utils/eventBus";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from '@/components/ui/form'
  import {i18n} from "@/utils/i18n";
  import {cn} from "@/utils/utils";
  import {CalendarDate, DateFormatter, getLocalTimeZone, parseDate, today} from "@internationalized/date";
  import {Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover";
  import {Calendar} from "@/components/ui/calendar";
  import {Calendar as CalendarIcon} from 'lucide-vue-next'
  import TablesService from "@/services/tables/tables.service";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RciEditForm',
  props: {
    coverageId: {},
    entity: {},
    open: { type: Boolean },
    setOpen: {}
  },
  setup(__props: any) {

  const props = __props
  const { emit } = useEventsBus();
  let newRci: any = {};
  const formSchema = toTypedSchema(z.object({
    date: z.string(),
    value: z.number(),
    })
  )
  const { handleSubmit, values, setValues } = useForm({
    validationSchema: formSchema,
  })

  const df = new DateFormatter('it-IT', {
    dateStyle: 'long',
  })
  const date = computed({
    get: () => values.date ? parseDate(values.date) : undefined,
    set: val => val,
  })
  const datePlaceholder = ref();

  watch(values, (newFormData) => {
    if (values.value) {
      setValues({value: +values.value})
    }
    newRci = newFormData;
  });

  const onSubmit = handleSubmit(async () => {
    let res;
    newRci.coverageId = props.coverageId
    res = await TablesService.addRci(newRci);
    if (res != undefined) {
      emit('update_'+props.entity, res.data);
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-w-[60vw]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('table.add')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "mt-3"
              }, [
                _createVNode(_unref(FormField), { name: "date" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormItem), { class: "flex flex-col" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('column.date')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(Popover), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(FormControl), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Button), {
                                      variant: "outline",
                                      class: _normalizeClass(_unref(cn)(
                  'w-full ps-3 text-start font-normal',
                  !date.value && 'text-muted-foreground',
                ))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(date.value ? _unref(df).format(new Date(date.value as any)) : _unref(i18n).global.t('column.date')), 1),
                                        _createVNode(_unref(CalendarIcon), { class: "ms-auto h-4 w-4 opacity-50" })
                                      ]),
                                      _: 1
                                    }, 8, ["class"]),
                                    _hoisted_1
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(PopoverContent), { class: "w-auto p-0" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Calendar), {
                                  placeholder: datePlaceholder.value,
                                  "onUpdate:placeholder": _cache[0] || (_cache[0] = ($event: any) => ((datePlaceholder).value = $event)),
                                  modelValue: date.value,
                                  "onUpdate:modelValue": [
                                    _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
                                    _cache[2] || (_cache[2] = (v) => {
                if (v) {
                  _unref(setValues)({
                    date: v.toString(),
                  })
                }
                else {
                  _unref(setValues)({
                    date: '',
                  })
                }

              })
                                  ],
                                  "calendar-label": _unref(i18n).global.t('column.date'),
                                  "initial-focus": "",
                                  "min-value": new (_unref(CalendarDate))(2000, 1, 1),
                                  "max-value": _unref(today)(_unref(getLocalTimeZone)())
                                }, null, 8, ["placeholder", "modelValue", "calendar-label", "min-value", "max-value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "value" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('column.rci')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.rci')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogFooter), { class: "mt-6" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogClose), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), { type: "submit" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})